/* Formulare (Kontakt, Händler, Beratungs-Dialog, Newsletter): Prüfung direkt beim Verlassen eines Feldes, eigene
   verständliche Meldungen unter dem Feld statt der Browser-Sprechblase, und ein Lade-Zustand im Senden-Button gegen
   doppeltes Absenden. Formulare mit eigener Logik (Grillfinder) und versteckte Formulare bleiben unberührt. */
(function () {
  "use strict";
  if (window.__azForms) return;
  window.__azForms = true;

  var lang = (document.documentElement.lang || "de").slice(0, 2);
  var T = {
    de: { req: "Bitte fülle dieses Feld aus.", email: "Bitte gib eine gültige E-Mail-Adresse ein, z. B. name@beispiel.ch.", tel: "Bitte gib eine Telefonnummer mit mindestens 9 Ziffern ein.", check: "Bitte bestätige dieses Feld.", sending: "Wird gesendet …" },
    fr: { req: "Merci de remplir ce champ.", email: "Merci d'indiquer une adresse e-mail valide, p. ex. nom@exemple.ch.", tel: "Merci d'indiquer un numéro de téléphone d'au moins 9 chiffres.", check: "Merci de confirmer ce champ.", sending: "Envoi en cours …" },
    it: { req: "Compila questo campo.", email: "Inserisci un indirizzo e-mail valido, ad es. nome@esempio.ch.", tel: "Inserisci un numero di telefono di almeno 9 cifre.", check: "Conferma questo campo.", sending: "Invio in corso …" },
    en: { req: "Please fill in this field.", email: "Please enter a valid email address, e.g. name@example.ch.", tel: "Please enter a phone number with at least 9 digits.", check: "Please confirm this field.", sending: "Sending …" }
  }[lang] || null;
  if (!T) T = { req: "Bitte fülle dieses Feld aus.", email: "Bitte gib eine gültige E-Mail-Adresse ein.", tel: "Bitte gib eine gültige Telefonnummer ein.", check: "Bitte bestätige dieses Feld.", sending: "Wird gesendet …" };

  function eligible(form) {
    if (!form || form.hidden || form.closest("[hidden]")) return false;
    if (form.matches("[data-az-finder-lead], [data-az-lead-manual], .az-finder__leadform")) return false;
    var ft = form.querySelector('input[name="form_type"]');
    return !!ft && (ft.value === "contact" || ft.value === "customer");
  }
  function fields(form) {
    return Array.prototype.filter.call(form.querySelectorAll("input, textarea, select"), function (f) {
      return f.type !== "hidden" && f.type !== "submit" && !f.disabled;
    });
  }
  function problem(f) {
    var v = (f.value || "").trim();
    if (f.type === "checkbox") return f.required && !f.checked ? T.check : "";
    if (f.required && !v) return T.req;
    if (!v) return "";
    if (f.type === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) return T.email;
    if (f.type === "tel" && v.replace(/\D/g, "").length < 9) return T.tel;
    return "";
  }
  function show(f, msg) {
    var id = (f.id || f.name || "f").replace(/[^\w-]/g, "") + "-az-err";
    var box = f.parentNode.querySelector(".az-field-error[data-for='" + id + "']");
    if (msg) {
      if (!box) {
        box = document.createElement("small");
        box.className = "az-field-error";
        box.setAttribute("data-for", id);
        box.id = id;
        box.setAttribute("role", "alert");
        f.insertAdjacentElement("afterend", box);
      }
      box.textContent = msg;
      f.setAttribute("aria-invalid", "true");
      f.setAttribute("aria-describedby", id);
      f.classList.add("az-invalid");
    } else {
      if (box) box.remove();
      f.removeAttribute("aria-invalid");
      f.classList.remove("az-invalid");
    }
  }
  function check(f) { var m = problem(f); show(f, m); return !m; }

  function prepare(form) {
    if (form.__azPrepared) return;
    form.__azPrepared = true;
    form.noValidate = true;
    fields(form).forEach(function (f) {
      f.addEventListener("blur", function () { if (f.value || f.classList.contains("az-invalid")) check(f); });
      f.addEventListener("input", function () { if (f.classList.contains("az-invalid")) check(f); });
      if (f.type === "checkbox") f.addEventListener("change", function () { check(f); });
    });
  }
  function scan() { document.querySelectorAll("form").forEach(function (fm) { if (eligible(fm)) prepare(fm); }); }

  /* Capture-Phase: läuft vor allen anderen Absende-Skripten (Tracking, Beratungs-Dialog) */
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!eligible(form)) return;
    prepare(form);
    var bad = fields(form).filter(function (f) { return !check(f); });
    if (bad.length) {
      e.preventDefault();
      e.stopImmediatePropagation();
      bad[0].focus({ preventScroll: true });
      bad[0].scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }
    var btn = form.querySelector('button[type="submit"], button:not([type]), input[type="submit"]');
    if (btn && !btn.classList.contains("az-busy")) {
      btn.classList.add("az-busy");
      btn.setAttribute("aria-busy", "true");
      btn.dataset.azLabel = btn.innerHTML;
      /* erst nach dem Absenden sperren, sonst bricht der Browser das Senden ab */
      setTimeout(function () { btn.disabled = true; }, 0);
      /* Falls ein Skript per fetch sendet und die Seite bleibt: nach 8 s wieder freigeben */
      setTimeout(function () {
        btn.disabled = false; btn.classList.remove("az-busy"); btn.removeAttribute("aria-busy");
      }, 8000);
    }
  }, true);

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan); else scan();
  /* Formulare, die später erscheinen (Beratungs-Dialog), beim ersten Fokus vorbereiten */
  document.addEventListener("focusin", function (e) { var fm = e.target.form; if (fm && eligible(fm)) prepare(fm); });
})();
